import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import ServiceProviderAppResource from "./ServiceProviderAppResource";
import MarketAppResource from "./MarketAppResource";

class ServiceProviderLocationAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'service-provider-location';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'services/providers/locations';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'street',
            'city',
            'state',
            'zip',
            'stateCode',
            'countyFipsCode',
            'latitude',
            'longitude',
            'serviceProviderUuid',
            'serviceProvider',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            market: MarketAppResource,
            serviceProvider: ServiceProviderAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            serviceProvider: 'service_provider_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            street: {
                type: 'string',
            },
            city: {
                type: 'string',
            },
            state: {
                type: 'string',
            },
            zip: {
                type: 'string',
                presence: true,
            },
            stateCode: {
                type: 'string',
            },
            countyFipsCode: {
                type: 'string',
            },
            latitude: {
                type: 'string',
                format: {
                    pattern: '^[-]?(([0-8]?[0-9])\\.(\\d+))|(90(\\.0+)?)$/',
                    message: 'is invalid.',
                },
            },
            longitude: {
                type: 'string',
                format: {
                    pattern: '^(\\+|-)?(?:180(?:(?:\\.0{1,6})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\\.[0-9]{1,6})?))$',
                    message: 'is invalid.',
                },
            },
            serviceProviderUuid: {
                type: 'string',
            },
        };
    }
}

export default ServiceProviderLocationAppResource;
